<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">申购</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>五折申购</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create-discount @refresh="getProjectList"></create-discount>
      </div>
      <list @refresh="getProjectList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import List from './components/list';
import CreateDiscount from './components/createDiscount';

export default {
  name: 'discount',
  data() {
    return {
      seeDay: 0
    };
  },
  components: {
    List,
    CreateDiscount
  },
  computed: {
    ...mapState('discount', ['pagination'])
  },
  methods: {
    ...mapActions('discount', [
      'getList',
      'getCoinTypeList',
      'getRelativePrice',
      'getaward'
    ]),
    getProjectList(data = {}) {
      this.getList({
        type: 1,
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    this.getProjectList({ type: 1 });
    this.getCoinTypeList();
    this.getaward();
  }
};
</script>
